export const firebaseConfig = {
    apiKey: 'AIzaSyC0gY-4-WDxY8sltFpN5qfcUo5z7QqdJCw',
    authDomain: 'vox-sandboxx.firebaseapp.com',
    projectId: 'vox-sandboxx',
    storageBucket: 'vox-sandboxx.appspot.com',
    messagingSenderId: '106748558266',
    appId: '1:106748558266:web:5bce4d19f9e428e49c7b83'
};
